document.querySelector('.top-header-menu--search .search-icon').addEventListener('click', function() {
    let searchForm = document.querySelector('.search-form-metz');
    let searchOne = document.querySelector('.search-icon');
   
    if (searchForm || searchOne) {
        searchForm.classList.toggle('is-active');
        searchOne.classList.toggle('cross');
        // Change content inside the cross
        if (searchOne.classList.contains('cross')) {
            searchOne.innerHTML = 'TIMES'; // Change content to 'X'
        } else {
            searchOne.innerHTML = 'SEARCH'; // Change content back to default '☰'
        }
    }
});

document.querySelector('.metz-search-icon').addEventListener('click',function(e){
    e.preventDefault();
})

document.querySelector('.top-header-menu--search.two .search-icon').addEventListener('click', function() {
    let searchFormTwo = document.querySelector('.search-form-metz.two');
    let searchIcon = document.querySelector('.search-icon');
    if (searchFormTwo || searchIcon) {
        searchFormTwo.classList.toggle('is-active');
        this.classList.toggle('cross');
        // Change content inside the cross
        if (this.classList.contains('cross')) {
            this.innerHTML = 'TIMES'; // Change content to 'X'
        } else {
            this.innerHTML = 'SEARCH'; // Change content back to default '☰'
        }
    }
});
